// The app's thumbnail queue. Components import this module only, so tests can mock it.
import { createMaplibreRenderer } from './maplibreThumbnailRenderer';
import { createThumbnailQueue } from './thumbnailQueue';

export const thumbnailQueue = createThumbnailQueue({ createRenderer: createMaplibreRenderer });
